import styled from "styled-components";
import Checkbox from "@streeteasy/design-system/deprecated/Checkbox";
import colors from "@streeteasy/design-system/deprecated/colors";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextArea from "@streeteasy/design-system/deprecated/TextArea";
import Title from "@streeteasy/design-system/deprecated/Title";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const ContactPreferences = styled.div`
  margin: 16px 0;
`;

export const ContactPreferencesCheckbox = styled(Checkbox)`
  margin-right: 15px;

  ${({ isInvalid }) =>
    isInvalid &&
    `
    span:nth-child(2) {
      border-color: ${colors.errorRed};
    }
  `}
`;

export const ErrorText = styled(Text).attrs({
  type: "sm"
})`
  color: ${colors.errorRed};
  margin-top: 3px;
  text-transform: none;
`;

export const ContactPreferencesError = styled(ErrorText)`
  margin-top: 5px;
`;

export const ContactPreferencesFields = styled.div`
  display: flex;
`;

export const ContactPreferencesTitle = styled(Title).attrs({
  as: "p",
  type: "secondarySmCaps"
})`
  color: ${colors.koalaGrey};
  margin-bottom: 12px;
`;

export const Content = styled.div`
  padding: 70px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 38px 52px 150px;
  }
`;

export const DisclaimerText = styled(Text).attrs({
  type: "disclaimer"
})``;

export const FormText = styled(Text).attrs({
  type: "sm"
})`
  margin-bottom: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 16px;
  }
`;

export const FormTextArea = styled(TextArea).attrs({
  height: "122px"
})`
  margin-top: 5px;
`;

export const FormTextInput = styled(Input)`
  margin-top: 5px;
`;

export const FormTitle = styled(Title).attrs({
  as: "h2",
  type: "primarySm"
})`
  margin-bottom: 16px;
`;

export const Label = styled(Title).attrs({
  as: "label",
  type: "secondarySmCaps"
})`
  color: ${colors.koalaGrey};
  display: block;
  margin: 0 0 16px;
`;

export const Spacer = styled.div`
  border-bottom: 1px solid ${colors.rabbitGrey};
  height: 1px;
  margin: 40px 0 20px;
`;

export const TermsAndConditionsContainer = styled.div`
  margin-top: 20px;
  text-align: center;
`;

export const TermsAndConditionsLink = styled.a`
  border-bottom: 1px solid ${colors.koalaGrey};
  color: ${colors.koalaGrey};
  text-decoration: none;
`;
